(function () {
  const OPEN_CLASS = 'tooltip-open';
  const DISMISSED_CLASS = 'tooltip-dismissed';

  let hoveredTrigger = null;

  function findTrigger(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return null;

    const ownTrigger = element.closest('[data-tooltip]');
    if (ownTrigger) return ownTrigger;

    const labels = element.labels;
    if (!labels) return null;

    for (const label of labels) {
      const labelTrigger = label.closest('[data-tooltip]');
      if (labelTrigger) return labelTrigger;
    }

    return null;
  }

  function isVisible(trigger) {
    if (!trigger || trigger.classList.contains(DISMISSED_CLASS)) return false;
    return trigger.classList.contains(OPEN_CLASS) || trigger.matches(':hover');
  }

  document.addEventListener('focusin', function (event) {
    const trigger = findTrigger(event.target);
    // Keyboard focus only: a mouse click, or script returning focus after one (the PDP swap),
    // would otherwise leave the tooltip open with the pointer gone.
    if (!trigger || !event.target.matches(':focus-visible')) return;

    trigger.classList.remove(DISMISSED_CLASS);
    trigger.classList.add(OPEN_CLASS);
  });

  document.addEventListener('focusout', function (event) {
    const trigger = findTrigger(event.target);
    if (!trigger) return;

    trigger.classList.remove(OPEN_CLASS, DISMISSED_CLASS);
  });

  document.addEventListener('mouseover', function (event) {
    const trigger = findTrigger(event.target);
    if (trigger === hoveredTrigger) return;

    if (hoveredTrigger) hoveredTrigger.classList.remove(DISMISSED_CLASS);
    hoveredTrigger = trigger;
  });

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;

      const focusedTrigger = findTrigger(document.activeElement);
      let trigger = null;

      if (isVisible(focusedTrigger)) {
        trigger = focusedTrigger;
      } else if (isVisible(hoveredTrigger)) {
        trigger = hoveredTrigger;
      }

      if (!trigger) return;

      trigger.classList.remove(OPEN_CLASS);
      trigger.classList.add(DISMISSED_CLASS);

      event.stopPropagation();
    },
    true
  );
})();
